import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		exCardData: [], // 存储兑换卡册信息
		selectCardGoodsData: {}, // 存储卡册密码兑换选择的商品信息
		orderData: [], // 存储订单查询信息
	},
	mutations: {
		setExCardData(state, data) {
			state.exCardData.length = 0;
			state.exCardData.push(data);
		},
		setSelectCardGoodsData(state, data) {
			Object.assign(state.selectCardGoodsData, data);
		},
		setOrderData(state, data) {
			state.orderData.length = 0;
			state.orderData = data;
		}
	},
	actions: {},
	modules: {}
})